export default "__VITE_ASSET__BLTjpqDk__"